import isNil from 'lodash/isNil';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { IntersectionDetector } from 'zoomforth_zfutils/viewport_intersection_utils.js';
import {
  animationClassGenerator,
  ConditionalWrapper,
} from 'zoomforth_page_version_viewer/utils.js';
import { setTextLinksToDisplayExternalOpenMsg } from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const GridTileInnerTypeText_ViewerVersion1 = ({
  tellRef,
  verticalAlign,
  horizontalAlign,
  htmlContent,
  animationSettings,
}) => {
  const style = {};

  if (verticalAlign) {
    style['verticalAlign'] = verticalAlign;
  }

  if (horizontalAlign) {
    style['textAlign'] = horizontalAlign;
  }

  let animationClasses;
  let animationRunsOnce = true;

  if (animationSettings) {
    const { animationType, animationSpeed, animationRepeats } =
      animationSettings;
    animationClasses = animationClassGenerator(animationType, animationSpeed);
    if (!isNil(animationRepeats)) {
      animationRunsOnce = !animationRepeats;
    }
  }

  return (
    <ConditionalWrapper
      condition={!isNil(animationSettings)}
      wrapper={(children) => (
        <IntersectionDetector
          animationClasses={animationClasses}
          triggerOnce={animationRunsOnce}
        >
          {children}
        </IntersectionDetector>
      )}
    >
      <div
        ref={tellRef}
        className={'tile-text'}
        style={style}
        // do not set inner html if it is a form
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </ConditionalWrapper>
  );
};

class GridTileInnerTypeText_ViewerVersion2 extends Component {
  constructor(props) {
    super(props);
    this.wrapperNodeRef = null;
  }

  componentDidMount() {
    this.doPostRender();
  }

  componentDidUpdate() {
    this.doPostRender();
  }

  doPostRender() {
    setTextLinksToDisplayExternalOpenMsg(this.wrapperNodeRef, 'a');
  }

  render() {
    return (
      <GridTileInnerTypeText_ViewerVersion1
        {...this.props}
        tellRef={(ref) => {
          this.wrapperNodeRef = ref;
        }}
      />
    );
  }
}

const GridTileInnerTypeText = (props) => (
  <SiteViewerVersionComponentSelector>
    <GridTileInnerTypeText_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <GridTileInnerTypeText_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

GridTileInnerTypeText.propTypes = {
  htmlContent: PropTypes.string,
  horizontalAlign: PropTypes.string,
  verticalAlign: PropTypes.string,
};

export default GridTileInnerTypeText;
